import { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

type EditorProps = React.ComponentProps<typeof ReactQuill> & {
  image?: boolean;
};

export default function EditorComponent(props: EditorProps) {
  const [value, setValue] = useState('');

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'indent',
    'link',
    ...(props.image ? ['image'] : []),
  ];

  const modules = {
    toolbar: [
      [{ header: '1' }, { header: '2' }, { header: '3' }],
      ['bold', 'italic', 'underline', 'strike'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' },
      ],
      ...(props.image ? [['link', 'image']] : [['link']]),
      ['clean'],
    ],
  };

  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={setValue}
      formats={formats}
      modules={modules}
      {...props}
    />
  );
}
